import { Box } from '@mui/material';

// Components
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import Form from './WarehouseStock/Form';

function WarehouseStock() {
  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Topbar breadcrumbs={[{ label: 'สต็อกคลังสินค้า' }]} />
      <Box component="main" sx={{ flexGrow: 1, ml: 'var(--sidebar-width, 220px)', mt: '56px', p: 3, minHeight: 'calc(100vh - 56px)' }}>
        <Form name={'สต็อกคลังสินค้า'} />
      </Box>
    </Box>
  );
}

export default WarehouseStock;
